/**
 * Placeholder AI assessment output until backend / model integration exists.
 * Reviewers can apply these drafts to the form and edit freely.
 */

export type AiAssessmentSuggestion = {
  decision: 'has-potential' | 'no-potential';
  ipTypes: string[];
  recommendation: string;
  rationale: string;
  criteriaNotes: { criterionId: string; note: string }[];
  confidenceLabel: string;
};

export const MOCK_AI_ASSESSMENT: AiAssessmentSuggestion = {
  decision: 'has-potential',
  ipTypes: ['Patent', 'Copyright'],
  recommendation:
    'The submission describes a concrete technical approach with documentation suitable for Intellectual Property review. ' +
    'Consider pursuing patent protection for the core process where novelty can be articulated in claims, and Copyright for ' +
    'software and written materials. Recommend a formal prior art search before filing.',
  rationale:
    'Automated scan of abstract and keywords suggests alignment with protectable subject matter; ' +
    'independent verification of novelty and non-obviousness remains required.',
  criteriaNotes: [
    {
      criterionId: 'novelty-uniqueness',
      note: 'Differentiation from generic solutions is stated; verify against closest prior art.',
    },
    {
      criterionId: 'ip-protection',
      note: 'Mixed Patent and Copyright relevance likely; confirm ownership chain in submissions.',
    },
  ],
  confidenceLabel: 'Indicative (preview)',
};
